import { Link } from "react-router-dom";

const LandingFooter = () => {
  return (
    <footer className="lp-footer">
        <div className="lp-container">
            <div className="lp-footer-links">
                <Link to="/preguntas-frecuentes">Preguntas frecuentes</Link>
                <Link to="/terminos-y-condiciones">Términos</Link>
                <Link to="/politicas-de-privacidad">Privacidad</Link>
                <a href="mailto:contacto@miqrapp.com">Contacto</a>
                <a href="https://www.instagram.com/miqrapp" target="_blank" rel="noreferrer">Instagram</a>
                <Link to="/arrepentimiento" className="lp-footer-strong">Botón de arrepentimiento</Link>
            </div>
            <span>© MiQRapp · Hecho en Argentina</span>
        </div>
    </footer>
  )
}

export default LandingFooter
